import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { GlossaryTerm } from "../constants";

interface TermsListProps {
  terms: GlossaryTerm[];
  letter: string;
  category: string;
}

export const TermsList: React.FC<TermsListProps> = ({
  terms,
  letter,
  category,
}) => {
  if (terms.length === 0) {
    return (
      <div className="bg-white border border-[#E5E7EB] p-8 text-center">
        <p className="text-[#6B7280] text-lg">
          No terms found starting with &ldquo;{letter.toUpperCase()}&rdquo;
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white border border-[#E5E7EB] overflow-hidden">
      {terms.map((term, index) => (
        <div key={term.term}>
          <div className="flex flex-col gap-2 p-6">
            <div className="min-w-[200px] max-w-[300px]">
              <RouterLink
                to={`/glossary/${category}/${letter.toLowerCase()}/${term.term
                  .toLowerCase()
                  .replace(/\s+/g, "-")
                  .replace(/[^\w-]/g, "")}`}
                className="text-[#ED6E5C] hover:text-[#D85D4A] font-[AeonikPro] font-semibold text-lg hover:underline"
              >
                {term.term}
              </RouterLink>
            </div>
            <div className="flex-1">
              <p className="text-[#334155] text-base leading-7">
                {term.definition}
              </p>
            </div>
          </div>
          {index < terms.length - 1 && (
            <div className="border-t border-[#E5E7EB]" />
          )}
        </div>
      ))}
    </div>
  );
};
